export const PICTUREURL = '';
export const SERVICEPICTUREURL = '';
export const PRODUCTURL = 'http://gym.sz-sport.cn/';
export const COMMON_URL = 'http://gym.sz-sport.cn/sport';


// export const PRODUCTURL = 'http://www.j2eetea.cn/';
// export const COMMON_URL = 'http://www.j2eetea.cn/mall';

export const INDEX_API = `${COMMON_URL}/api/mall/getMallInfo`;
export const VENUE_INFO = `${COMMON_URL}/api/mall/venue`;
export const SITE_LIST = `${COMMON_URL}/api/mall/site`;

export const VENUE_DETAIL_INFO = `${COMMON_URL}/api/venue`;


export const ORDER_LIST = `${COMMON_URL}/api/order/list`;
export const ORDER_CREATE = `${COMMON_URL}/api/order/create`;
export const ORDER_CREATE_PAY = `${COMMON_URL}/api/order/createPay`;
export const ORDER_CREATE_PAGE = `${COMMON_URL}/api/order/createOrderPage`;

export const ORDER_QUERY = `${COMMON_URL}/api/order/query`;
export const REFUND_URL = `${COMMON_URL}/api/order/refund`;
export const ORDER_CONSUME = `${COMMON_URL}/api/order/consume`;

export const PAYMENT_URL = `${COMMON_URL}/api/order/payment`;
export const API_PAY = `${COMMON_URL}/api/order/payRequest`;


export const SPACE_LIST = `${COMMON_URL}/api/user/spaceList`;

export const USER_LOGIN = `${COMMON_URL}/api/user/login`;
export const OAUTH_URL = `${COMMON_URL}/api/user/oauth`;
export const USER_ACCESS_loginToken = `${COMMON_URL}/api/user/accessToken`;

export const LOGIN = `${COMMON_URL}/api/user/userLogin`;

export const CHECK_loginToken = `${COMMON_URL}/api/user/token`;


export const USER_REGISTER = `${COMMON_URL}/api/user/isRegister`;

export const USER_SMS_CODE = `${COMMON_URL}/api/user/smsCode`;


export const USER_BIND_PHONE = `${COMMON_URL}/api/user/phoneLogin`;
export const USER_INFO = `${COMMON_URL}/api/user/getUserInfo`;
export const USER_RECHARGE_LIST = `${COMMON_URL}/api/user/getUserRechargeList`;

export const MEMBER_LOGIN = `${COMMON_URL}/api/user/memberLogin`;

export const USER_SMS_CODE_CHECK = `${COMMON_URL}/api/user/checkSmsCode`;
export const USER_FIND_PASSWORD = `${COMMON_URL}/api/user/updatePassword`;
export const USER_UPDATE_INFO = `${COMMON_URL}/api/user/updateUserInfo`;

export const MEMBER_RECHARGE = `${COMMON_URL}/api/member/recharge`;


export const IMAGE_URL = `http://gym.sz-sport.cn/photo/`






